import './styles.scss'
import { useContext } from 'react'
import { t } from 'i18next'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import { getAccessButtonAndInfo } from 'Utils/subscriptionAccess'
import DialogUIModal from 'Components/UIComponent/DialogUIModal'
import CreateAccountInfoModal from 'Components/UIComponent/CreateAccountInfoModal'
import microSignalsUtils from '../../utils/microSignals.utils'

const HistoryCertifiedLotsDataModal = ({ certifiedLotsHistoryData, historyCertifiedModalTitle, isCertifiedLotsHistoryPopupOpen, setIsCertifiedLotsHistoryPopupOpen, formatNumber, checkForUserAccess, isPlatinumUser }) => {
  const { determineCellClass, determineCompareToPreviousDayClass } = microSignalsUtils
  const { realtimeSubscriptionData } = useContext(CoffeeWebContext)

  const handleClose = () => {
    setIsCertifiedLotsHistoryPopupOpen(false)
  }

  const { buttonText, infoMessage, className, navigationPath, state } = getAccessButtonAndInfo({ realtimeSubscriptionData })

  const dialogModalContent = () => (
    <div className="history-macro-signals-data-table-wrapper">
      <table className="macro-signals-table">
        <thead>
          <tr>
            <th className="date-td">{t('REPORT_DATE')}</th>
            <th className="certified-stocks-td">{t('CERTIFIED_STOCKS')}</th>
            <th className="compare-to-pre-td">{t('COMPARE_TO_PRE_DAY')}</th>
            <th className="not-tenderable-td">{`${historyCertifiedModalTitle === '1' ? t('NON_TENDERABLE') : t('PENDING_GRADING_REPORT')}`}</th>
            <th className="suspended-td">{`${historyCertifiedModalTitle === '1' ? t('SUSPENDED') : t('DAILY_GRADING_SUMMARY')}`}</th>
          </tr>
        </thead>

        <tbody style={checkForUserAccess(!isPlatinumUser)}>
          {certifiedLotsHistoryData?.length === 0 ? (
            <tr>
              <td colSpan="5" className="table-loader">
                {t('LOADING_DATA')}
              </td>
            </tr>
          ) : (
            certifiedLotsHistoryData.map((item, index) => {
              const previousCertifiedStocks = certifiedLotsHistoryData?.[index + 1]?.certifiedStocks || item?.certifiedStocks
              const certifiedStockColor = determineCellClass(item?.certifiedStocks, previousCertifiedStocks)

              return (
                <tr key={index}>
                  <td className="macro-signals-date">{item?.Date || item?.date}</td>
                  <td className={certifiedStockColor}>{formatNumber(Math.round(item?.certifiedStocks))}</td>
                  <td className={determineCompareToPreviousDayClass(item?.ComparedToPreDay)}>{formatNumber(Math.round(item?.ComparedToPreDay))}</td>
                  <td>{`${historyCertifiedModalTitle === '1' ? Math.round(item?.nonTenderable) : item?.PendingGradingReport}`}</td>
                  <td>{`${historyCertifiedModalTitle === '1' ? item?.suspended : item?.grading}`}</td>
                </tr>
              )
            })
          )}
        </tbody>
      </table>
      {!isPlatinumUser && (
        <div className="history-certified-lot-create-account-info-modal-popup">
          <CreateAccountInfoModal buttonText={buttonText} infoMessage={infoMessage} className={className} navigationPath={navigationPath} state={state} testId="coffee-reports-create-account-modal" />
        </div>
      )}
    </div>
  )

  return <DialogUIModal size="lg" titlePosition="center" title={`${historyCertifiedModalTitle === '1' ? t('ROBUSTA') : t('ARABICA')}  ${t('CERTIFIED_LOTS')} ${t('HISTORY_DATA')}`} showModal={isCertifiedLotsHistoryPopupOpen} handleClose={handleClose} bodyContent={dialogModalContent} />
}

export default HistoryCertifiedLotsDataModal
